<template>
  <div :class="`member__user member__user-${activeTab === 30 ? 'senior' : 'basic'}`">
    <div class="card__user">
      <div v-if="(activeTab === 30 && showSeniorBtn === 2) || (activeTab === 20 && showSeniorBtn === 2)" class="faq"
        @click="showFaq(activeTab)"></div>
      <div class="top">
        <img class="avator" v-if="userInfo.avatar" :src="userInfo.avatar" />
        <img class="avator" v-if="!userInfo.avatar" src="@/assets/img/personalImg/defaultAvatar.png" alt="" />
        <div class="name">
          <div class="text" v-if="!userInfo.id" @click="generateOrder(0)">登录/注册</div>
          <div class="text" v-if="userInfo.id">{{ userInfo.nickName }}</div>
          <img class="level" v-if="activeTab === 20 && [10, 20, 40, 50, 60].includes(userMemberInfo.level)"
            :src="`${$global.OSS_IMAGE_PREFIX}/ark-student-wap/member/member_basic1.png`" />
          <img class="level" v-if="activeTab === 30 && userMemberInfo.level === 30"
            :src="`${$global.OSS_IMAGE_PREFIX}/ark-student-wap/member/member_senior1.png`" alt="" />
        </div>
        <div class="btn_trial"
          v-if="activeTab === 20 && !(userMemberInfo.level || (!userMemberInfo.level && userMemberInfo.isTryoutMember)) && showTrialBtn"
          @click="generateOrder(10)">免费领取3天</div>
        <div class="btn_trial"
          v-if="userMemberInfo.level === 0 && isShowBuy && ((activeTab === 20 && userMemberInfo?.beforeMemberLevel === 20 && userMemberInfo.isTryoutMember && showBasicBtn === 2) || (activeTab === 30 && userMemberInfo?.beforeMemberLevel === 30 && showSeniorBtn === 2))"
          @click="generateOrder(activeTab)">续费</div>
        <div class="btn_trial"
          v-if="userMemberInfo.level === 0 && !isShowBuy && ((activeTab === 20 && userMemberInfo?.beforeMemberLevel === 20 && userMemberInfo.isTryoutMember && showBasicBtn === 2) || (activeTab === 30 && userMemberInfo?.beforeMemberLevel === 30 && showSeniorBtn === 2))"
          @click="openChat">联系客服</div>
        <div class="btn_trial" v-if="activeTab === 20 && userMemberInfo.level === 20 && showSeniorBtn === 2"
          @click="goSenior">升级</div>
      </div>
      <div v-if="showExpired" class="expired">有效期至{{ userMemberInfo.deadlineEndTime }}</div>
      <div v-if="showPerson" class="expired">已有{{ number }}人开通{{ activeTab === 20 ? '星耀直通卡' : '研力特权卡' }}</div>
    </div>
    <div class="card__benefits">
      <template v-if="benefits.length" style="background: #fff;">
        <div class="card__benefits-top">
          <div class="benefits__top_title">{{ isUnlock ? '已' : '' }}解锁{{ benefits.length }}项权益</div>
          <div class="benefits__top_btn" @click="handleToggle" v-if="isUnlock">
            {{ isToggle ? '收起' : '展开' }}
            <span v-if="isToggle" class="benefits_btn benefits_btn-up"></span>
            <span v-if="!isToggle" class="benefits_btn benefits_btn-down"></span>
          </div>
        </div>
        <div :class="`benefits__icons ${!isUnlock || benefitsClass ? 'open' : ''}`">
          <div class="benefits__icons-item" v-for="(item, index) in benefits" :key="item.title + index"
            @click="viewBenefits(index)">
            <img class="benefits__icon" :src="item.icon" />
            <span class="benefits__desc">{{ item.title }}</span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    benefits: {
      type: Array,
      value: [],
    },
    activeTab: {
      type: Number,
      value: 20,
    },
    number: {
      type: Number,
      value: 0,
    },
    userMemberInfo: {
      type: Object,
      default: () => ({
        level: 0, // 0 普通用户 10 试用会员 20 普通会员 30 高级会员
        levelName: '普通用户',
        deadlineStartTime: '',
        deadlineEndTime: '', // 会员到期时间
        isTryoutMember: null, // 是否领取过试用会员
        beforeMemberLevel: null, // 上一次会员等级
      }),
    },
    userInfo: {
      type: Object,
      default: () => ({}),
    },
    openChat: {
      type: Function,
      default: () => { },
    },
    generateOrder: {
      type: Function,
      default: () => { },
    },
    showFaq: {
      type: Function,
      default: () => { },
    },
    showTrialBtn: {
      type: Boolean,
      value: false,
    },
    showBasicBtn: {
      type: Number,
      value: 0,
    },
    showSeniorBtn: {
      type: Number,
      value: 0,
    },
  },
  data() {
    return {
      isToggle: false,
      isShowBuy: false,
    };
  },
  watch: {
    userMemberInfo: {
      handler(value) {
        this.isShowBuy = this.$root.miniprogram === false || this.$root.miniprogramBuyCourse;
      },
      deep: true,
      immediate: true,
    },
    activeTab() {
      this.isToggle = false;
    },
  },
  computed: {
    showExpired() {
      const { level } = this.userMemberInfo;
      const flag = (this.activeTab === 20 && [10, 20, 40, 50, 60].includes(level)) || (this.activeTab === 30 && [30].includes(level));
      return !!flag;
    },
    showPerson() {
      const { level } = this.userMemberInfo;
      const flag = (level === 0) || ([10, 40, 50, 60].includes(level) && this.activeTab === 30);
      return !!flag;
    },
    isUnlock() {
      const { level } = this.userMemberInfo;
      const flag = (this.activeTab === 20 && [10, 20, 40, 50, 60].includes(level)) || (this.activeTab === 30 && [30].includes(level));
      return !!flag;
    },
    benefitsClass() {
      const { level } = this.userMemberInfo;
      const flag = level === 0 ? true : this.isToggle;
      return !!flag;
    },
  },
  methods: {
    goSenior() {
      this.$router.push({
        path: '/personalCenter/seniorMember',
        query: {
          back: 'back',
          hiddenNavigationBar: 1,
        },
      });
    },
    handleToggle() {
      this.isToggle = !this.isToggle;
    },
    viewBenefits(index) {
      this.$router.push({
        path: '/personalCenter/benefits',
        query: {
          activeTab: this.activeTab,
          hiddenNavigationBar: 1,
          index,
          back: 'back',
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
@import '../../index.scss';

.member__user {
  width: 678px;
  margin: 0 auto;
  position: relative;

  .card__user {
    @include background(100%, 237px);
    padding: 36px 36px 0;
    position: relative;

    .top {
      display: flex;
      align-items: center;
    }
  }

  .avator {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    border: 4px solid #FFFFFF;
  }

  .name {
    margin-left: 22px;
    display: flex;
    height: 104px;
    flex-direction: column;
    justify-content: center;

    font-size: 36px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #60371C;
    line-height: 51px;
    flex: 1;
    width: 0;

    .text {
      width: 100%;
      flex: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .level {
    margin-top: 8px;
    @include background(130px, 43px);
  }

  .expired {
    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    line-height: 31px;
    margin-top: 25px;
  }

  .faq {
    @include background(130px, 43px);
    position: absolute;
    top: 0;
    right: 0;
  }

  .card__benefits {
    padding: 142px 0 32px;
    border-radius: 0px 0px 29px 29px;
    margin-top: -120px;

    &-top {
      display: flex;
      justify-content: space-between;
      height: 36px;
      padding: 0 25px 6px;
      align-items: center;
      color: #FFFFFF;
    }

    .benefits__top_title {
      font-size: 25px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
    }

    .benefits__top_btn {
      font-size: 22px;
      font-family: PingFangSC, PingFang SC;
    }

    .benefits_btn {
      @include background(25px, 25px);
      display: inline-flex;
      position: relative;
      top: 2px;
      margin-left: 7px;

      &-up {
        @include backgroundImage('benefits_up1.png')
      }

      &-down {
        @include backgroundImage('benefits_down1.png')
      }
    }

    .benefits__icons {
      display: flex;
      flex-wrap: wrap;
      height: 0;
      overflow: hidden;

      &-item {
        width: 20%;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 22px;
      }

      .benefits__icon {
        width: 72px;
        height: 72px;
      }

      .benefits__desc {
        font-size: 22px;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #F0E8E2;
        text-align: center;
        margin-top: 10px;
      }
    }

    .open {
      height: auto;
      overflow: visible;
    }
  }

  &-basic {
    .card__user {
      @include backgroundImage('member_user_basic.png');
    }

    .name {
      color: #60371C;
    }

    .expired {
      color: rgba(96, 55, 28, 1);
    }

    .faq {
      @include backgroundImage('faq_basic.png');
    }

    .card__benefits {
      background: rgba(168, 119, 76, 1);
    }
  }

  &-senior {

    .card__user {
      @include backgroundImage('member_user_senior.png');
    }

    .name {
      color: #FED2B3;
    }

    .expired {
      color: rgba(254, 210, 179, 1);
    }

    .faq {
      @include backgroundImage('faq_senior.png');
    }

    .card__benefits {
      background: rgba(64, 58, 59, 1);
    }
  }

  .btn_trial {
    // max-width: 185px;
    padding: 0 22px;
    min-width: 120px;
    height: 50px;
    background: linear-gradient(360deg, #211C20 0%, #3B3734 100%);
    border-radius: 27px;
    font-size: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFE2C4;
    line-height: 50px;
    text-align: center;
    align-self: flex-end;
  }
}
</style>
